import { Image, UIHeading2, UIHeading3 } from '@cian/ui-kit';
import * as React from 'react';
import cn from 'clsx';
import { ReactNode } from 'react';

import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../constants/mediaQueries';
import { IWithDeviceTypeProps, withDeviceType } from '../../utils/withDeviceType';

import * as styles from './styles.css';

const BannerLayout: React.FC<
  IWithDeviceTypeProps & {
    imageX1: string;
    imageX2: string;
    description: ReactNode;
    phone?: string;
    action?: ReactNode;
  }
> = props => {
  const imageSize = props.isDesktop ? 100 : 80;
  const TextComponent = props.isPhone ? UIHeading3 : UIHeading2;

  return (
    <div className={cn(styles['layout'], styles[props.deviceType])}>
      <Image
        width={imageSize}
        height={imageSize}
        src={props.imageX1}
        sources={[{ srcset: props.imageX2, media: X2_IMAGE_SIZE_MEDIA_QUERY }, { srcset: props.imageX1 }]}
        loading="lazy"
        objectFit="contain"
      />
      <TextComponent textAlign={props.isDesktop ? 'left' : 'center'} whiteSpace="pre-line" color="white_100">
        {props.description}
      </TextComponent>
      <div className={cn(styles['button'], styles[props.deviceType])}>{props.action}</div>
    </div>
  );
};

const BannerLayoutWithDeviceType = withDeviceType(BannerLayout);

export { BannerLayoutWithDeviceType as BannerLayout };
